import React, {useState, useEffect} from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';

import { withRouter } from "react-router";

import {Copyright} from '../../../components';

import { useFormik } from 'formik';

import {resetPassword} from '../../../services/auth.service';
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import {toast} from "../../../utils/utils";
import {TOAST_TYPES} from "../../../utils/constants";
import { getPasswordChecks } from "../../DQPro/DQProV2/components/PasswordWithValidationsField.comp";
import PasswordFieldWithChecklist from "../../../components/PasswordFieldWithChecklist/PasswordFieldWithChecklist.comp";

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: theme.palette.secondary.main,
    },
    form: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

const PasswordReset = (props) => {
    const classes = useStyles();

    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({ password: '', confirm_password: '' });

    const formik = useFormik({
        initialValues: {
            reset_code: '',
            password: '',
            confirm_password: ''
        },
        onSubmit: async (values) => {
            console.log('Form data => ', values);

            const newErrors = { password: '', confirm_password: '' };

            const checks = getPasswordChecks(values.password);
            if (!Object.values(checks).every(Boolean)) {
                newErrors.password = 'Password must include 8+ chars, upper, lower, number, and special character.';
            }

            if (values.password !== values.confirm_password) {
                newErrors.confirm_password = "The Confirm Password confirmation doesnt match.";
            }

            setErrors(newErrors);
            if (newErrors.password || newErrors.confirm_password) return;

            try {
                const result = await resetPassword(values.reset_code, values.password);
                console.log('result.data -> ', result.data);

                toast(TOAST_TYPES.SUCCESS, "Password Updated", "Successfully Changed Password")

                props.history.push('/login');
            } catch (e) {
                // already toasted the error
            }
        }
    });

    return (
        <Container component="main" maxWidth="xs">
            <CssBaseline />
            <div className={classes.paper}>
                <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                </Avatar>
                <Typography component="h1" variant="h5">
                    Reset Password
                </Typography>
                <form className={classes.form} noValidate onSubmit={formik.handleSubmit}>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            required
                            fullWidth
                            name="reset_code"
                            label="Reset Code"
                            type="text"
                            id="reset_code"
                            autoComplete="current-password"
                            onChange={formik.handleChange}
                            value={formik.values.reset_code}
                        />
                    </Grid>
                    <br />
                    <Grid item xs={12}>
                        <PasswordFieldWithChecklist
                            components={{ TextField, InputAdornment, IconButton, Box, Typography }}
                            showChecklist
                            variant="outlined"
                            required
                            fullWidth
                            name="password"
                            label="Password"
                            id="password"
                            autoComplete="current-password"
                            onChange={formik.handleChange}
                            value={formik.values.password}
                            helperText="Min 8 characters, with uppercase, lowercase, a number, and a special character."
                        />
                        {errors.password && (
                            <Typography style={{ color: '#d32f2f', fontSize: '13px', marginTop: '6px', fontWeight: '400' }}>
                                {errors.password}
                            </Typography>
                        )}
                    </Grid>
                    <br/>
                    <Grid item xs={12}>
                        <PasswordFieldWithChecklist
                            components={{ TextField, InputAdornment, IconButton, Box, Typography }}
                            variant="outlined"
                            required
                            fullWidth
                            name="confirm_password"
                            label="Confirm Password"
                            id="confirm_password"
                            autoComplete="current-password"
                            onChange={formik.handleChange}
                            value={formik.values.confirm_password}
                        />
                        {errors.confirm_password && (
                            <Typography style={{ color: '#d32f2f', fontSize: '13px', marginTop: '6px', fontWeight: '400' }}>
                                {errors.confirm_password}
                            </Typography>
                        )}
                    </Grid>

                    <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        color="primary"
                        className={classes.submit}
                    >
                        Set Password
                    </Button>
                    <Grid container>
                        <Grid item xs>
                            <Link href="/login" variant="body2">
                                Back to Login Page
                            </Link>
                        </Grid>
                    </Grid>

                </form>
            </div>
            <Box mt={8}>
                <Copyright />
            </Box>

            <LoaderWithBackDrop loading={loading} />

        </Container>
    );
}

export default withRouter(PasswordReset);